// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"lQ","selections":"mQ","pillsDesktopSearchMenu":"nQ"};